export const getFileSize = (file) => {
  var fileSize = file.size;
  var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
    i = 0; while (fileSize > 900) { fileSize /= 1024; i++; }
  return (Math.round(fileSize * 100) / 100) + ' ' + fSExt[i];
}
